import { PaymentAmount } from '@make-transfer/types/common';

class PaymentAmounts {
  // eslint-disable-next-line class-methods-use-this
  getRecentAmounts(formId: string, reverse: boolean = true, userId?: string): PaymentAmount[] {
    // eslint-disable-next-line i18next/no-literal-string
    const recentAmounts = JSON.parse(localStorage.getItem(`recentAmounts-${formId}-${userId || ''}`) || '[]');
    return reverse ? recentAmounts.slice(0).reverse() : recentAmounts;
  }

  saveRecentAmount(formId: string, amount: number, userId?: string): PaymentAmount[] {
    const recentAmount: PaymentAmount = {
      amount,
    };

    const amounts = this.getRecentAmounts(formId, false, userId);

    if (!amounts.find((item) => item.amount === recentAmount.amount)) {
      amounts.push(recentAmount);
    }

    if (amounts.length > 3) {
      amounts.shift();
    }

    // eslint-disable-next-line i18next/no-literal-string
    localStorage.setItem(`recentAmounts-${formId}-${userId || ''}`, JSON.stringify(amounts));

    return amounts;
  }
}

export const PaymentAmountsService = new PaymentAmounts();
